import React from "react";
import AddVideo from './AddVideo.jsx';
import VideoList from './VideoList.jsx';

export default function AddManageVideo() {
  
  return (
    <>
        <AddVideo/>
        <VideoList/>
    </>
    
  );
}